import {get, post} from "@/config/api";

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
  EmitCounter({}, params) {
    return new Promise((resolve, reject) => {
      post("base/metric/emit_counter/", params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  }


};

export default {
  state,
  getters,
  actions,
  mutations,
};
